var map = {
	"./vp/assistance.newtask": "./app/javascript/images/vp/assistance.newtask.svg",
	"./vp/assistance.newtask.svg": "./app/javascript/images/vp/assistance.newtask.svg",
	"./vp/bg.authcols": "./app/javascript/images/vp/bg.authcols.svg",
	"./vp/bg.authcols.svg": "./app/javascript/images/vp/bg.authcols.svg",
	"./vp/bg.authcols.title": "./app/javascript/images/vp/bg.authcols.title.svg",
	"./vp/bg.authcols.title.svg": "./app/javascript/images/vp/bg.authcols.title.svg",
	"./vp/bg.gift.instructions": "./app/javascript/images/vp/bg.gift.instructions.png",
	"./vp/bg.gift.instructions.png": "./app/javascript/images/vp/bg.gift.instructions.png",
	"./vp/bg.heart.blue": "./app/javascript/images/vp/bg.heart.blue.png",
	"./vp/bg.heart.blue.png": "./app/javascript/images/vp/bg.heart.blue.png",
	"./vp/bg.heart.red": "./app/javascript/images/vp/bg.heart.red.png",
	"./vp/bg.heart.red.png": "./app/javascript/images/vp/bg.heart.red.png",
	"./vp/bg.heart2.red": "./app/javascript/images/vp/bg.heart2.red.png",
	"./vp/bg.heart2.red.png": "./app/javascript/images/vp/bg.heart2.red.png",
	"./vp/bg.rightcol": "./app/javascript/images/vp/bg.rightcol.png",
	"./vp/bg.rightcol.png": "./app/javascript/images/vp/bg.rightcol.png",
	"./vp/bg.task.heart": "./app/javascript/images/vp/bg.task.heart.svg",
	"./vp/bg.task.heart.svg": "./app/javascript/images/vp/bg.task.heart.svg",
	"./vp/dobro.logo": "./app/javascript/images/vp/dobro.logo.svg",
	"./vp/dobro.logo.svg": "./app/javascript/images/vp/dobro.logo.svg",
	"./vp/header.phone": "./app/javascript/images/vp/header.phone.png",
	"./vp/header.phone.png": "./app/javascript/images/vp/header.phone.png",
	"./vp/headerimg.desk": "./app/javascript/images/vp/headerimg.desk.jpg",
	"./vp/headerimg.desk.jpg": "./app/javascript/images/vp/headerimg.desk.jpg",
	"./vp/headerimg.mobi": "./app/javascript/images/vp/headerimg.mobi.jpg",
	"./vp/headerimg.mobi.jpg": "./app/javascript/images/vp/headerimg.mobi.jpg",
	"./vp/icon.addfriend.white": "./app/javascript/images/vp/icon.addfriend.white.svg",
	"./vp/icon.addfriend.white.svg": "./app/javascript/images/vp/icon.addfriend.white.svg",
	"./vp/icon.addtask.black": "./app/javascript/images/vp/icon.addtask.black.svg",
	"./vp/icon.addtask.black.svg": "./app/javascript/images/vp/icon.addtask.black.svg",
	"./vp/icon.addtask.red": "./app/javascript/images/vp/icon.addtask.red.svg",
	"./vp/icon.addtask.red.svg": "./app/javascript/images/vp/icon.addtask.red.svg",
	"./vp/icon.addtask.white": "./app/javascript/images/vp/icon.addtask.white.svg",
	"./vp/icon.addtask.white.svg": "./app/javascript/images/vp/icon.addtask.white.svg",
	"./vp/icon.arrow.left.gray": "./app/javascript/images/vp/icon.arrow.left.gray.svg",
	"./vp/icon.arrow.left.gray.svg": "./app/javascript/images/vp/icon.arrow.left.gray.svg",
	"./vp/icon.arrow.right.gray": "./app/javascript/images/vp/icon.arrow.right.gray.svg",
	"./vp/icon.arrow.right.gray.svg": "./app/javascript/images/vp/icon.arrow.right.gray.svg",
	"./vp/icon.award.gray": "./app/javascript/images/vp/icon.award.gray.svg",
	"./vp/icon.award.gray.svg": "./app/javascript/images/vp/icon.award.gray.svg",
	"./vp/icon.award.red": "./app/javascript/images/vp/icon.award.red.svg",
	"./vp/icon.award.red.svg": "./app/javascript/images/vp/icon.award.red.svg",
	"./vp/icon.burgerdots.red": "./app/javascript/images/vp/icon.burgerdots.red.svg",
	"./vp/icon.burgerdots.red.svg": "./app/javascript/images/vp/icon.burgerdots.red.svg",
	"./vp/icon.burgerdots.white": "./app/javascript/images/vp/icon.burgerdots.white.svg",
	"./vp/icon.burgerdots.white.svg": "./app/javascript/images/vp/icon.burgerdots.white.svg",
	"./vp/icon.camera.white": "./app/javascript/images/vp/icon.camera.white.svg",
	"./vp/icon.camera.white.svg": "./app/javascript/images/vp/icon.camera.white.svg",
	"./vp/icon.checkbox.off.gray": "./app/javascript/images/vp/icon.checkbox.off.gray.svg",
	"./vp/icon.checkbox.off.gray.svg": "./app/javascript/images/vp/icon.checkbox.off.gray.svg",
	"./vp/icon.checkbox.on.red": "./app/javascript/images/vp/icon.checkbox.on.red.svg",
	"./vp/icon.checkbox.on.red.svg": "./app/javascript/images/vp/icon.checkbox.on.red.svg",
	"./vp/icon.chevrondown": "./app/javascript/images/vp/icon.chevrondown.svg",
	"./vp/icon.chevrondown.svg": "./app/javascript/images/vp/icon.chevrondown.svg",
	"./vp/icon.city.red": "./app/javascript/images/vp/icon.city.red.svg",
	"./vp/icon.city.red.svg": "./app/javascript/images/vp/icon.city.red.svg",
	"./vp/icon.close.black": "./app/javascript/images/vp/icon.close.black.svg",
	"./vp/icon.close.black.svg": "./app/javascript/images/vp/icon.close.black.svg",
	"./vp/icon.comment.outline.black": "./app/javascript/images/vp/icon.comment.outline.black.svg",
	"./vp/icon.comment.outline.black.svg": "./app/javascript/images/vp/icon.comment.outline.black.svg",
	"./vp/icon.copy": "./app/javascript/images/vp/icon.copy.svg",
	"./vp/icon.copy.svg": "./app/javascript/images/vp/icon.copy.svg",
	"./vp/icon.delete.black": "./app/javascript/images/vp/icon.delete.black.svg",
	"./vp/icon.delete.black.svg": "./app/javascript/images/vp/icon.delete.black.svg",
	"./vp/icon.delete.gray": "./app/javascript/images/vp/icon.delete.gray.svg",
	"./vp/icon.delete.gray.svg": "./app/javascript/images/vp/icon.delete.gray.svg",
	"./vp/icon.delete.outline.black": "./app/javascript/images/vp/icon.delete.outline.black.svg",
	"./vp/icon.delete.outline.black.svg": "./app/javascript/images/vp/icon.delete.outline.black.svg",
	"./vp/icon.delete.red": "./app/javascript/images/vp/icon.delete.red.svg",
	"./vp/icon.delete.red.svg": "./app/javascript/images/vp/icon.delete.red.svg",
	"./vp/icon.deletebutton.red": "./app/javascript/images/vp/icon.deletebutton.red.svg",
	"./vp/icon.deletebutton.red.svg": "./app/javascript/images/vp/icon.deletebutton.red.svg",
	"./vp/icon.document.red": "./app/javascript/images/vp/icon.document.red.svg",
	"./vp/icon.document.red.svg": "./app/javascript/images/vp/icon.document.red.svg",
	"./vp/icon.document.white": "./app/javascript/images/vp/icon.document.white.svg",
	"./vp/icon.document.white.svg": "./app/javascript/images/vp/icon.document.white.svg",
	"./vp/icon.download.red": "./app/javascript/images/vp/icon.download.red.svg",
	"./vp/icon.download.red.svg": "./app/javascript/images/vp/icon.download.red.svg",
	"./vp/icon.download.white": "./app/javascript/images/vp/icon.download.white.svg",
	"./vp/icon.download.white.svg": "./app/javascript/images/vp/icon.download.white.svg",
	"./vp/icon.download2.red": "./app/javascript/images/vp/icon.download2.red.svg",
	"./vp/icon.download2.red.svg": "./app/javascript/images/vp/icon.download2.red.svg",
	"./vp/icon.dropdown.black": "./app/javascript/images/vp/icon.dropdown.black.svg",
	"./vp/icon.dropdown.black.svg": "./app/javascript/images/vp/icon.dropdown.black.svg",
	"./vp/icon.dropdown.white": "./app/javascript/images/vp/icon.dropdown.white.svg",
	"./vp/icon.dropdown.white.svg": "./app/javascript/images/vp/icon.dropdown.white.svg",
	"./vp/icon.edit.black": "./app/javascript/images/vp/icon.edit.black.svg",
	"./vp/icon.edit.black.svg": "./app/javascript/images/vp/icon.edit.black.svg",
	"./vp/icon.edit.outline.black": "./app/javascript/images/vp/icon.edit.outline.black.svg",
	"./vp/icon.edit.outline.black.svg": "./app/javascript/images/vp/icon.edit.outline.black.svg",
	"./vp/icon.event": "./app/javascript/images/vp/icon.event.svg",
	"./vp/icon.event.svg": "./app/javascript/images/vp/icon.event.svg",
	"./vp/icon.events": "./app/javascript/images/vp/icon.events.svg",
	"./vp/icon.events.svg": "./app/javascript/images/vp/icon.events.svg",
	"./vp/icon.fb.red": "./app/javascript/images/vp/icon.fb.red.png",
	"./vp/icon.fb.red.png": "./app/javascript/images/vp/icon.fb.red.png",
	"./vp/icon.fb.white": "./app/javascript/images/vp/icon.fb.white.png",
	"./vp/icon.fb.white.png": "./app/javascript/images/vp/icon.fb.white.png",
	"./vp/icon.filter": "./app/javascript/images/vp/icon.filter.svg",
	"./vp/icon.filter.red": "./app/javascript/images/vp/icon.filter.red.svg",
	"./vp/icon.filter.red.svg": "./app/javascript/images/vp/icon.filter.red.svg",
	"./vp/icon.filter.svg": "./app/javascript/images/vp/icon.filter.svg",
	"./vp/icon.filter.white": "./app/javascript/images/vp/icon.filter.white.svg",
	"./vp/icon.filter.white.svg": "./app/javascript/images/vp/icon.filter.white.svg",
	"./vp/icon.geo.red": "./app/javascript/images/vp/icon.geo.red.svg",
	"./vp/icon.geo.red.svg": "./app/javascript/images/vp/icon.geo.red.svg",
	"./vp/icon.gifts": "./app/javascript/images/vp/icon.gifts.svg",
	"./vp/icon.gifts.svg": "./app/javascript/images/vp/icon.gifts.svg",
	"./vp/icon.heart": "./app/javascript/images/vp/icon.heart.svg",
	"./vp/icon.heart.darkred": "./app/javascript/images/vp/icon.heart.darkred.svg",
	"./vp/icon.heart.darkred.svg": "./app/javascript/images/vp/icon.heart.darkred.svg",
	"./vp/icon.heart.red": "./app/javascript/images/vp/icon.heart.red.svg",
	"./vp/icon.heart.red.svg": "./app/javascript/images/vp/icon.heart.red.svg",
	"./vp/icon.heart.svg": "./app/javascript/images/vp/icon.heart.svg",
	"./vp/icon.heart.white": "./app/javascript/images/vp/icon.heart.white.svg",
	"./vp/icon.heart.white.svg": "./app/javascript/images/vp/icon.heart.white.svg",
	"./vp/icon.hours.gray": "./app/javascript/images/vp/icon.hours.gray.png",
	"./vp/icon.hours.gray.png": "./app/javascript/images/vp/icon.hours.gray.png",
	"./vp/icon.hours.red": "./app/javascript/images/vp/icon.hours.red.png",
	"./vp/icon.hours.red.png": "./app/javascript/images/vp/icon.hours.red.png",
	"./vp/icon.in.red": "./app/javascript/images/vp/icon.in.red.png",
	"./vp/icon.in.red.png": "./app/javascript/images/vp/icon.in.red.png",
	"./vp/icon.in.white": "./app/javascript/images/vp/icon.in.white.png",
	"./vp/icon.in.white.png": "./app/javascript/images/vp/icon.in.white.png",
	"./vp/icon.index.organizations": "./app/javascript/images/vp/icon.index.organizations.svg",
	"./vp/icon.index.organizations.svg": "./app/javascript/images/vp/icon.index.organizations.svg",
	"./vp/icon.info.black": "./app/javascript/images/vp/icon.info.black.svg",
	"./vp/icon.info.black.svg": "./app/javascript/images/vp/icon.info.black.svg",
	"./vp/icon.leftarrow2.black": "./app/javascript/images/vp/icon.leftarrow2.black.svg",
	"./vp/icon.leftarrow2.black.svg": "./app/javascript/images/vp/icon.leftarrow2.black.svg",
	"./vp/icon.leftarrow2.blue": "./app/javascript/images/vp/icon.leftarrow2.blue.svg",
	"./vp/icon.leftarrow2.blue.svg": "./app/javascript/images/vp/icon.leftarrow2.blue.svg",
	"./vp/icon.leftarrow2.darkblue": "./app/javascript/images/vp/icon.leftarrow2.darkblue.svg",
	"./vp/icon.leftarrow2.darkblue.svg": "./app/javascript/images/vp/icon.leftarrow2.darkblue.svg",
	"./vp/icon.leftarrow2.red": "./app/javascript/images/vp/icon.leftarrow2.red.svg",
	"./vp/icon.leftarrow2.red.svg": "./app/javascript/images/vp/icon.leftarrow2.red.svg",
	"./vp/icon.leftarrow2.white": "./app/javascript/images/vp/icon.leftarrow2.white.svg",
	"./vp/icon.leftarrow2.white.svg": "./app/javascript/images/vp/icon.leftarrow2.white.svg",
	"./vp/icon.linked": "./app/javascript/images/vp/icon.linked.png",
	"./vp/icon.linked.png": "./app/javascript/images/vp/icon.linked.png",
	"./vp/icon.logo.mainslider": "./app/javascript/images/vp/icon.logo.mainslider.svg",
	"./vp/icon.logo.mainslider.svg": "./app/javascript/images/vp/icon.logo.mainslider.svg",
	"./vp/icon.mail.black": "./app/javascript/images/vp/icon.mail.black.svg",
	"./vp/icon.mail.black.svg": "./app/javascript/images/vp/icon.mail.black.svg",
	"./vp/icon.mail.red": "./app/javascript/images/vp/icon.mail.red.svg",
	"./vp/icon.mail.red.svg": "./app/javascript/images/vp/icon.mail.red.svg",
	"./vp/icon.menu.events.black": "./app/javascript/images/vp/icon.menu.events.black.svg",
	"./vp/icon.menu.events.black.svg": "./app/javascript/images/vp/icon.menu.events.black.svg",
	"./vp/icon.menu.events.red": "./app/javascript/images/vp/icon.menu.events.red.svg",
	"./vp/icon.menu.events.red.svg": "./app/javascript/images/vp/icon.menu.events.red.svg",
	"./vp/icon.menu.gift.gray": "./app/javascript/images/vp/icon.menu.gift.gray.svg",
	"./vp/icon.menu.gift.gray.svg": "./app/javascript/images/vp/icon.menu.gift.gray.svg",
	"./vp/icon.menu.gift.red": "./app/javascript/images/vp/icon.menu.gift.red.svg",
	"./vp/icon.menu.gift.red.svg": "./app/javascript/images/vp/icon.menu.gift.red.svg",
	"./vp/icon.menu.help.black": "./app/javascript/images/vp/icon.menu.help.black.svg",
	"./vp/icon.menu.help.black.svg": "./app/javascript/images/vp/icon.menu.help.black.svg",
	"./vp/icon.menu.help.red": "./app/javascript/images/vp/icon.menu.help.red.svg",
	"./vp/icon.menu.help.red.svg": "./app/javascript/images/vp/icon.menu.help.red.svg",
	"./vp/icon.menu.help2.black": "./app/javascript/images/vp/icon.menu.help2.black.svg",
	"./vp/icon.menu.help2.black.svg": "./app/javascript/images/vp/icon.menu.help2.black.svg",
	"./vp/icon.menu.help2.red": "./app/javascript/images/vp/icon.menu.help2.red.svg",
	"./vp/icon.menu.help2.red.svg": "./app/javascript/images/vp/icon.menu.help2.red.svg",
	"./vp/icon.menu.info.black": "./app/javascript/images/vp/icon.menu.info.black.svg",
	"./vp/icon.menu.info.black.svg": "./app/javascript/images/vp/icon.menu.info.black.svg",
	"./vp/icon.menu.info.red": "./app/javascript/images/vp/icon.menu.info.red.svg",
	"./vp/icon.menu.info.red.svg": "./app/javascript/images/vp/icon.menu.info.red.svg",
	"./vp/icon.menu.info.white": "./app/javascript/images/vp/icon.menu.info.white.svg",
	"./vp/icon.menu.info.white.svg": "./app/javascript/images/vp/icon.menu.info.white.svg",
	"./vp/icon.menu.news.black": "./app/javascript/images/vp/icon.menu.news.black.svg",
	"./vp/icon.menu.news.black.svg": "./app/javascript/images/vp/icon.menu.news.black.svg",
	"./vp/icon.menu.news.red": "./app/javascript/images/vp/icon.menu.news.red.svg",
	"./vp/icon.menu.news.red.svg": "./app/javascript/images/vp/icon.menu.news.red.svg",
	"./vp/icon.menu.tasks.black": "./app/javascript/images/vp/icon.menu.tasks.black.svg",
	"./vp/icon.menu.tasks.black.svg": "./app/javascript/images/vp/icon.menu.tasks.black.svg",
	"./vp/icon.menu.tasks.red": "./app/javascript/images/vp/icon.menu.tasks.red.svg",
	"./vp/icon.menu.tasks.red.svg": "./app/javascript/images/vp/icon.menu.tasks.red.svg",
	"./vp/icon.noaccount.white": "./app/javascript/images/vp/icon.noaccount.white.svg",
	"./vp/icon.noaccount.white.svg": "./app/javascript/images/vp/icon.noaccount.white.svg",
	"./vp/icon.notifications.black": "./app/javascript/images/vp/icon.notifications.black.svg",
	"./vp/icon.notifications.black.svg": "./app/javascript/images/vp/icon.notifications.black.svg",
	"./vp/icon.notifications.red": "./app/javascript/images/vp/icon.notifications.red.png",
	"./vp/icon.notifications.red.png": "./app/javascript/images/vp/icon.notifications.red.png",
	"./vp/icon.notifications.red.svg": "./app/javascript/images/vp/icon.notifications.red.svg",
	"./vp/icon.ok.red": "./app/javascript/images/vp/icon.ok.red.png",
	"./vp/icon.ok.red.png": "./app/javascript/images/vp/icon.ok.red.png",
	"./vp/icon.ok.white": "./app/javascript/images/vp/icon.ok.white.png",
	"./vp/icon.ok.white.png": "./app/javascript/images/vp/icon.ok.white.png",
	"./vp/icon.pdf.bg.red": "./app/javascript/images/vp/icon.pdf.bg.red.png",
	"./vp/icon.pdf.bg.red.png": "./app/javascript/images/vp/icon.pdf.bg.red.png",
	"./vp/icon.people": "./app/javascript/images/vp/icon.people.svg",
	"./vp/icon.people.svg": "./app/javascript/images/vp/icon.people.svg",
	"./vp/icon.personremove.white": "./app/javascript/images/vp/icon.personremove.white.svg",
	"./vp/icon.personremove.white.svg": "./app/javascript/images/vp/icon.personremove.white.svg",
	"./vp/icon.phone.red": "./app/javascript/images/vp/icon.phone.red.svg",
	"./vp/icon.phone.red.svg": "./app/javascript/images/vp/icon.phone.red.svg",
	"./vp/icon.profile.tg.red": "./app/javascript/images/vp/icon.profile.tg.red.svg",
	"./vp/icon.profile.tg.red.svg": "./app/javascript/images/vp/icon.profile.tg.red.svg",
	"./vp/icon.profile.whatsup.red": "./app/javascript/images/vp/icon.profile.whatsup.red.svg",
	"./vp/icon.profile.whatsup.red.svg": "./app/javascript/images/vp/icon.profile.whatsup.red.svg",
	"./vp/icon.removefriend.white": "./app/javascript/images/vp/icon.removefriend.white.svg",
	"./vp/icon.removefriend.white.svg": "./app/javascript/images/vp/icon.removefriend.white.svg",
	"./vp/icon.rightarrow": "./app/javascript/images/vp/icon.rightarrow.png",
	"./vp/icon.rightarrow.blue": "./app/javascript/images/vp/icon.rightarrow.blue.svg",
	"./vp/icon.rightarrow.blue.svg": "./app/javascript/images/vp/icon.rightarrow.blue.svg",
	"./vp/icon.rightarrow.gray": "./app/javascript/images/vp/icon.rightarrow.gray.svg",
	"./vp/icon.rightarrow.gray.svg": "./app/javascript/images/vp/icon.rightarrow.gray.svg",
	"./vp/icon.rightarrow.png": "./app/javascript/images/vp/icon.rightarrow.png",
	"./vp/icon.rightarrow.red": "./app/javascript/images/vp/icon.rightarrow.red.svg",
	"./vp/icon.rightarrow.red.svg": "./app/javascript/images/vp/icon.rightarrow.red.svg",
	"./vp/icon.rightarrow.white": "./app/javascript/images/vp/icon.rightarrow.white.svg",
	"./vp/icon.rightarrow.white.svg": "./app/javascript/images/vp/icon.rightarrow.white.svg",
	"./vp/icon.rightarrow2": "./app/javascript/images/vp/icon.rightarrow2.svg",
	"./vp/icon.rightarrow2.black": "./app/javascript/images/vp/icon.rightarrow2.black.svg",
	"./vp/icon.rightarrow2.black.svg": "./app/javascript/images/vp/icon.rightarrow2.black.svg",
	"./vp/icon.rightarrow2.blue": "./app/javascript/images/vp/icon.rightarrow2.blue.png",
	"./vp/icon.rightarrow2.blue.png": "./app/javascript/images/vp/icon.rightarrow2.blue.png",
	"./vp/icon.rightarrow2.darkblue": "./app/javascript/images/vp/icon.rightarrow2.darkblue.svg",
	"./vp/icon.rightarrow2.darkblue.svg": "./app/javascript/images/vp/icon.rightarrow2.darkblue.svg",
	"./vp/icon.rightarrow2.lightblue": "./app/javascript/images/vp/icon.rightarrow2.lightblue.svg",
	"./vp/icon.rightarrow2.lightblue.svg": "./app/javascript/images/vp/icon.rightarrow2.lightblue.svg",
	"./vp/icon.rightarrow2.red": "./app/javascript/images/vp/icon.rightarrow2.red.png",
	"./vp/icon.rightarrow2.red.png": "./app/javascript/images/vp/icon.rightarrow2.red.png",
	"./vp/icon.rightarrow2.red.svg": "./app/javascript/images/vp/icon.rightarrow2.red.svg",
	"./vp/icon.rightarrow2.svg": "./app/javascript/images/vp/icon.rightarrow2.svg",
	"./vp/icon.rightarrow2.white": "./app/javascript/images/vp/icon.rightarrow2.white.svg",
	"./vp/icon.rightarrow2.white.svg": "./app/javascript/images/vp/icon.rightarrow2.white.svg",
	"./vp/icon.roof.black": "./app/javascript/images/vp/icon.roof.black.svg",
	"./vp/icon.roof.black.svg": "./app/javascript/images/vp/icon.roof.black.svg",
	"./vp/icon.rt.red": "./app/javascript/images/vp/icon.rt.red.png",
	"./vp/icon.rt.red.png": "./app/javascript/images/vp/icon.rt.red.png",
	"./vp/icon.rt.white": "./app/javascript/images/vp/icon.rt.white.png",
	"./vp/icon.rt.white.png": "./app/javascript/images/vp/icon.rt.white.png",
	"./vp/icon.search": "./app/javascript/images/vp/icon.search.png",
	"./vp/icon.search.black": "./app/javascript/images/vp/icon.search.black.svg",
	"./vp/icon.search.black.svg": "./app/javascript/images/vp/icon.search.black.svg",
	"./vp/icon.search.png": "./app/javascript/images/vp/icon.search.png",
	"./vp/icon.search.svg": "./app/javascript/images/vp/icon.search.svg",
	"./vp/icon.sharebutton": "./app/javascript/images/vp/icon.sharebutton.png",
	"./vp/icon.sharebutton.blue": "./app/javascript/images/vp/icon.sharebutton.blue.svg",
	"./vp/icon.sharebutton.blue.svg": "./app/javascript/images/vp/icon.sharebutton.blue.svg",
	"./vp/icon.sharebutton.png": "./app/javascript/images/vp/icon.sharebutton.png",
	"./vp/icon.sharebutton.red": "./app/javascript/images/vp/icon.sharebutton.red.svg",
	"./vp/icon.sharebutton.red.svg": "./app/javascript/images/vp/icon.sharebutton.red.svg",
	"./vp/icon.sharebutton.svg": "./app/javascript/images/vp/icon.sharebutton.svg",
	"./vp/icon.sharebutton.white": "./app/javascript/images/vp/icon.sharebutton.white.svg",
	"./vp/icon.sharebutton.white.svg": "./app/javascript/images/vp/icon.sharebutton.white.svg",
	"./vp/icon.sliderarrow": "./app/javascript/images/vp/icon.sliderarrow.svg",
	"./vp/icon.sliderarrow.svg": "./app/javascript/images/vp/icon.sliderarrow.svg",
	"./vp/icon.star.blue": "./app/javascript/images/vp/icon.star.blue.svg",
	"./vp/icon.star.blue.svg": "./app/javascript/images/vp/icon.star.blue.svg",
	"./vp/icon.star.gray": "./app/javascript/images/vp/icon.star.gray.svg",
	"./vp/icon.star.gray.svg": "./app/javascript/images/vp/icon.star.gray.svg",
	"./vp/icon.star.red": "./app/javascript/images/vp/icon.star.red.svg",
	"./vp/icon.star.red.svg": "./app/javascript/images/vp/icon.star.red.svg",
	"./vp/icon.statistics.white": "./app/javascript/images/vp/icon.statistics.white.svg",
	"./vp/icon.statistics.white.svg": "./app/javascript/images/vp/icon.statistics.white.svg",
	"./vp/icon.submenu.edu.black": "./app/javascript/images/vp/icon.submenu.edu.black.svg",
	"./vp/icon.submenu.edu.black.svg": "./app/javascript/images/vp/icon.submenu.edu.black.svg",
	"./vp/icon.submenu.edu.red": "./app/javascript/images/vp/icon.submenu.edu.red.svg",
	"./vp/icon.submenu.edu.red.svg": "./app/javascript/images/vp/icon.submenu.edu.red.svg",
	"./vp/icon.submenu.history.black": "./app/javascript/images/vp/icon.submenu.history.black.svg",
	"./vp/icon.submenu.history.black.svg": "./app/javascript/images/vp/icon.submenu.history.black.svg",
	"./vp/icon.submenu.history.red": "./app/javascript/images/vp/icon.submenu.history.red.svg",
	"./vp/icon.submenu.history.red.svg": "./app/javascript/images/vp/icon.submenu.history.red.svg",
	"./vp/icon.submenu.organizations.black": "./app/javascript/images/vp/icon.submenu.organizations.black.svg",
	"./vp/icon.submenu.organizations.black.svg": "./app/javascript/images/vp/icon.submenu.organizations.black.svg",
	"./vp/icon.submenu.organizations.red": "./app/javascript/images/vp/icon.submenu.organizations.red.svg",
	"./vp/icon.submenu.organizations.red.svg": "./app/javascript/images/vp/icon.submenu.organizations.red.svg",
	"./vp/icon.submenu.polls.black": "./app/javascript/images/vp/icon.submenu.polls.black.svg",
	"./vp/icon.submenu.polls.black.svg": "./app/javascript/images/vp/icon.submenu.polls.black.svg",
	"./vp/icon.submenu.polls.red": "./app/javascript/images/vp/icon.submenu.polls.red.svg",
	"./vp/icon.submenu.polls.red.svg": "./app/javascript/images/vp/icon.submenu.polls.red.svg",
	"./vp/icon.submenu.resourcecenters": "./app/javascript/images/vp/icon.submenu.resourcecenters.svg",
	"./vp/icon.submenu.resourcecenters.red": "./app/javascript/images/vp/icon.submenu.resourcecenters.red.svg",
	"./vp/icon.submenu.resourcecenters.red.svg": "./app/javascript/images/vp/icon.submenu.resourcecenters.red.svg",
	"./vp/icon.submenu.resourcecenters.svg": "./app/javascript/images/vp/icon.submenu.resourcecenters.svg",
	"./vp/icon.submenu.stats.black": "./app/javascript/images/vp/icon.submenu.stats.black.svg",
	"./vp/icon.submenu.stats.black.svg": "./app/javascript/images/vp/icon.submenu.stats.black.svg",
	"./vp/icon.submenu.stats.red": "./app/javascript/images/vp/icon.submenu.stats.red.svg",
	"./vp/icon.submenu.stats.red.svg": "./app/javascript/images/vp/icon.submenu.stats.red.svg",
	"./vp/icon.submenu.supportmeasures": "./app/javascript/images/vp/icon.submenu.supportmeasures.svg",
	"./vp/icon.submenu.supportmeasures.red": "./app/javascript/images/vp/icon.submenu.supportmeasures.red.svg",
	"./vp/icon.submenu.supportmeasures.red.svg": "./app/javascript/images/vp/icon.submenu.supportmeasures.red.svg",
	"./vp/icon.submenu.supportmeasures.svg": "./app/javascript/images/vp/icon.submenu.supportmeasures.svg",
	"./vp/icon.submenu.volonters.black": "./app/javascript/images/vp/icon.submenu.volonters.black.svg",
	"./vp/icon.submenu.volonters.black.svg": "./app/javascript/images/vp/icon.submenu.volonters.black.svg",
	"./vp/icon.submenu.volonters.red": "./app/javascript/images/vp/icon.submenu.volonters.red.svg",
	"./vp/icon.submenu.volonters.red.svg": "./app/javascript/images/vp/icon.submenu.volonters.red.svg",
	"./vp/icon.switcher.off": "./app/javascript/images/vp/icon.switcher.off.png",
	"./vp/icon.switcher.off.png": "./app/javascript/images/vp/icon.switcher.off.png",
	"./vp/icon.switcher.off.white": "./app/javascript/images/vp/icon.switcher.off.white.png",
	"./vp/icon.switcher.off.white.png": "./app/javascript/images/vp/icon.switcher.off.white.png",
	"./vp/icon.switcher.on": "./app/javascript/images/vp/icon.switcher.on.png",
	"./vp/icon.switcher.on.png": "./app/javascript/images/vp/icon.switcher.on.png",
	"./vp/icon.switcher.on.white": "./app/javascript/images/vp/icon.switcher.on.white.png",
	"./vp/icon.switcher.on.white.png": "./app/javascript/images/vp/icon.switcher.on.white.png",
	"./vp/icon.syncing": "./app/javascript/images/vp/icon.syncing.png",
	"./vp/icon.syncing.png": "./app/javascript/images/vp/icon.syncing.png",
	"./vp/icon.task": "./app/javascript/images/vp/icon.task.svg",
	"./vp/icon.task.svg": "./app/javascript/images/vp/icon.task.svg",
	"./vp/icon.tg.red": "./app/javascript/images/vp/icon.tg.red.png",
	"./vp/icon.tg.red.png": "./app/javascript/images/vp/icon.tg.red.png",
	"./vp/icon.trend.down": "./app/javascript/images/vp/icon.trend.down.svg",
	"./vp/icon.trend.down.svg": "./app/javascript/images/vp/icon.trend.down.svg",
	"./vp/icon.trend.up": "./app/javascript/images/vp/icon.trend.up.svg",
	"./vp/icon.trend.up.svg": "./app/javascript/images/vp/icon.trend.up.svg",
	"./vp/icon.tt.red": "./app/javascript/images/vp/icon.tt.red.png",
	"./vp/icon.tt.red.png": "./app/javascript/images/vp/icon.tt.red.png",
	"./vp/icon.tt.white": "./app/javascript/images/vp/icon.tt.white.png",
	"./vp/icon.tt.white.png": "./app/javascript/images/vp/icon.tt.white.png",
	"./vp/icon.url.red": "./app/javascript/images/vp/icon.url.red.svg",
	"./vp/icon.url.red.svg": "./app/javascript/images/vp/icon.url.red.svg",
	"./vp/icon.user.black": "./app/javascript/images/vp/icon.user.black.svg",
	"./vp/icon.user.black.svg": "./app/javascript/images/vp/icon.user.black.svg",
	"./vp/icon.vk.red": "./app/javascript/images/vp/icon.vk.red.png",
	"./vp/icon.vk.red.png": "./app/javascript/images/vp/icon.vk.red.png",
	"./vp/icon.vk.white": "./app/javascript/images/vp/icon.vk.white.png",
	"./vp/icon.vk.white.png": "./app/javascript/images/vp/icon.vk.white.png",
	"./vp/icon.vote.smile-1": "./app/javascript/images/vp/icon.vote.smile-1.svg",
	"./vp/icon.vote.smile-1.svg": "./app/javascript/images/vp/icon.vote.smile-1.svg",
	"./vp/icon.vote.smile-2": "./app/javascript/images/vp/icon.vote.smile-2.svg",
	"./vp/icon.vote.smile-2.svg": "./app/javascript/images/vp/icon.vote.smile-2.svg",
	"./vp/icon.vote.smile-3": "./app/javascript/images/vp/icon.vote.smile-3.svg",
	"./vp/icon.vote.smile-3.svg": "./app/javascript/images/vp/icon.vote.smile-3.svg",
	"./vp/icon.vote.star.gray": "./app/javascript/images/vp/icon.vote.star.gray.svg",
	"./vp/icon.vote.star.gray.svg": "./app/javascript/images/vp/icon.vote.star.gray.svg",
	"./vp/icon.vote.star.red": "./app/javascript/images/vp/icon.vote.star.red.svg",
	"./vp/icon.vote.star.red.svg": "./app/javascript/images/vp/icon.vote.star.red.svg",
	"./vp/icon.yt.red": "./app/javascript/images/vp/icon.yt.red.png",
	"./vp/icon.yt.red.png": "./app/javascript/images/vp/icon.yt.red.png",
	"./vp/icon.yt.white": "./app/javascript/images/vp/icon.yt.white.png",
	"./vp/icon.yt.white.png": "./app/javascript/images/vp/icon.yt.white.png",
	"./vp/logo": "./app/javascript/images/vp/logo.svg",
	"./vp/logo.svg": "./app/javascript/images/vp/logo.svg",
	"./vp/logo.white": "./app/javascript/images/vp/logo.white.svg",
	"./vp/logo.white.svg": "./app/javascript/images/vp/logo.white.svg",
	"./vp/mobileapps.android": "./app/javascript/images/vp/mobileapps.android.png",
	"./vp/mobileapps.android.png": "./app/javascript/images/vp/mobileapps.android.png",
	"./vp/mobileapps.android.svg": "./app/javascript/images/vp/mobileapps.android.svg",
	"./vp/mobileapps.ios": "./app/javascript/images/vp/mobileapps.ios.svg",
	"./vp/mobileapps.ios.svg": "./app/javascript/images/vp/mobileapps.ios.svg",
	"./vp/no.img": "./app/javascript/images/vp/no.img.png",
	"./vp/no.img.png": "./app/javascript/images/vp/no.img.png",
	"./vp/no.map": "./app/javascript/images/vp/no.map.png",
	"./vp/no.map.png": "./app/javascript/images/vp/no.map.png",
	"./vp/no.profile": "./app/javascript/images/vp/no.profile.png",
	"./vp/no.profile.png": "./app/javascript/images/vp/no.profile.png",
	"./vp/parallax.01.1": "./app/javascript/images/vp/parallax.01.1.png",
	"./vp/parallax.01.1.png": "./app/javascript/images/vp/parallax.01.1.png",
	"./vp/parallax.01.2": "./app/javascript/images/vp/parallax.01.2.png",
	"./vp/parallax.01.2.png": "./app/javascript/images/vp/parallax.01.2.png",
	"./vp/parallax.01.3": "./app/javascript/images/vp/parallax.01.3.png",
	"./vp/parallax.01.3.png": "./app/javascript/images/vp/parallax.01.3.png",
	"./vp/parallax.02.1": "./app/javascript/images/vp/parallax.02.1.png",
	"./vp/parallax.02.1.png": "./app/javascript/images/vp/parallax.02.1.png",
	"./vp/parallax.02.2": "./app/javascript/images/vp/parallax.02.2.png",
	"./vp/parallax.02.2.png": "./app/javascript/images/vp/parallax.02.2.png",
	"./vp/parallax.02.3": "./app/javascript/images/vp/parallax.02.3.png",
	"./vp/parallax.02.3.png": "./app/javascript/images/vp/parallax.02.3.png",
	"./vp/parallax.new.01": "./app/javascript/images/vp/parallax.new.01.svg",
	"./vp/parallax.new.01.svg": "./app/javascript/images/vp/parallax.new.01.svg",
	"./vp/parallax.new.02": "./app/javascript/images/vp/parallax.new.02.svg",
	"./vp/parallax.new.02.svg": "./app/javascript/images/vp/parallax.new.02.svg",
	"./vp/parallax.new.03.a": "./app/javascript/images/vp/parallax.new.03.a.svg",
	"./vp/parallax.new.03.a.svg": "./app/javascript/images/vp/parallax.new.03.a.svg",
	"./vp/parallax.new.03.b": "./app/javascript/images/vp/parallax.new.03.b.svg",
	"./vp/parallax.new.03.b.svg": "./app/javascript/images/vp/parallax.new.03.b.svg",
	"./vp/parallax.new.03.c": "./app/javascript/images/vp/parallax.new.03.c.svg",
	"./vp/parallax.new.03.c.svg": "./app/javascript/images/vp/parallax.new.03.c.svg",
	"./vp/parallax.new.04.a": "./app/javascript/images/vp/parallax.new.04.a.svg",
	"./vp/parallax.new.04.a.svg": "./app/javascript/images/vp/parallax.new.04.a.svg",
	"./vp/parallax.new.04.b": "./app/javascript/images/vp/parallax.new.04.b.svg",
	"./vp/parallax.new.04.b.svg": "./app/javascript/images/vp/parallax.new.04.b.svg",
	"./vp/parallax.new.04.c": "./app/javascript/images/vp/parallax.new.04.c.svg",
	"./vp/parallax.new.04.c.svg": "./app/javascript/images/vp/parallax.new.04.c.svg",
	"./vp/parallax.new.05.a": "./app/javascript/images/vp/parallax.new.05.a.svg",
	"./vp/parallax.new.05.a.svg": "./app/javascript/images/vp/parallax.new.05.a.svg",
	"./vp/parallax.new.05.b": "./app/javascript/images/vp/parallax.new.05.b.svg",
	"./vp/parallax.new.05.b.svg": "./app/javascript/images/vp/parallax.new.05.b.svg",
	"./vp/parallax.new.05.c": "./app/javascript/images/vp/parallax.new.05.c.svg",
	"./vp/parallax.new.05.c.svg": "./app/javascript/images/vp/parallax.new.05.c.svg",
	"./vp/parallax.new.06.a": "./app/javascript/images/vp/parallax.new.06.a.svg",
	"./vp/parallax.new.06.a.svg": "./app/javascript/images/vp/parallax.new.06.a.svg",
	"./vp/parallax.new.06.b": "./app/javascript/images/vp/parallax.new.06.b.svg",
	"./vp/parallax.new.06.b.svg": "./app/javascript/images/vp/parallax.new.06.b.svg",
	"./vp/parallax.new.06.c": "./app/javascript/images/vp/parallax.new.06.c.svg",
	"./vp/parallax.new.06.c.svg": "./app/javascript/images/vp/parallax.new.06.c.svg",
	"./vp/parallax.new.06.d": "./app/javascript/images/vp/parallax.new.06.d.svg",
	"./vp/parallax.new.06.d.svg": "./app/javascript/images/vp/parallax.new.06.d.svg",
	"./vp/parallax.temp.01": "./app/javascript/images/vp/parallax.temp.01.svg",
	"./vp/parallax.temp.01.svg": "./app/javascript/images/vp/parallax.temp.01.svg",
	"./vp/parallax.temp.02": "./app/javascript/images/vp/parallax.temp.02.svg",
	"./vp/parallax.temp.02.svg": "./app/javascript/images/vp/parallax.temp.02.svg",
	"./vp/parallax.temp.03": "./app/javascript/images/vp/parallax.temp.03.svg",
	"./vp/parallax.temp.03.svg": "./app/javascript/images/vp/parallax.temp.03.svg",
	"./vp/parallax.temp.04": "./app/javascript/images/vp/parallax.temp.04.svg",
	"./vp/parallax.temp.04.svg": "./app/javascript/images/vp/parallax.temp.04.svg",
	"./vp/parallax.temp.05": "./app/javascript/images/vp/parallax.temp.05.svg",
	"./vp/parallax.temp.05.svg": "./app/javascript/images/vp/parallax.temp.05.svg",
	"./vp/sample.course": "./app/javascript/images/vp/sample.course.jpg",
	"./vp/sample.course.jpg": "./app/javascript/images/vp/sample.course.jpg",
	"./vp/sample.course2": "./app/javascript/images/vp/sample.course2.jpg",
	"./vp/sample.course2.jpg": "./app/javascript/images/vp/sample.course2.jpg",
	"./vp/sample.course3": "./app/javascript/images/vp/sample.course3.jpg",
	"./vp/sample.course3.jpg": "./app/javascript/images/vp/sample.course3.jpg",
	"./vp/sample.db": "./app/javascript/images/vp/sample.db.jpg",
	"./vp/sample.db.jpg": "./app/javascript/images/vp/sample.db.jpg",
	"./vp/sample.map": "./app/javascript/images/vp/sample.map.png",
	"./vp/sample.map.png": "./app/javascript/images/vp/sample.map.png",
	"./vp/sample.practice": "./app/javascript/images/vp/sample.practice.jpg",
	"./vp/sample.practice.jpg": "./app/javascript/images/vp/sample.practice.jpg",
	"./vp/sample.practice2": "./app/javascript/images/vp/sample.practice2.jpg",
	"./vp/sample.practice2.jpg": "./app/javascript/images/vp/sample.practice2.jpg",
	"./vp/sample.practice3": "./app/javascript/images/vp/sample.practice3.jpg",
	"./vp/sample.practice3.jpg": "./app/javascript/images/vp/sample.practice3.jpg",
	"./vp/sample.profile": "./app/javascript/images/vp/sample.profile.png",
	"./vp/sample.profile.png": "./app/javascript/images/vp/sample.profile.png",
	"./vp/sample.shishkin": "./app/javascript/images/vp/sample.shishkin.jpg",
	"./vp/sample.shishkin.jpg": "./app/javascript/images/vp/sample.shishkin.jpg",
	"./vp/sample.taskimage": "./app/javascript/images/vp/sample.taskimage.jpg",
	"./vp/sample.taskimage.jpg": "./app/javascript/images/vp/sample.taskimage.jpg",
	"./vp/sample.taskimagethumb": "./app/javascript/images/vp/sample.taskimagethumb.png",
	"./vp/sample.taskimagethumb.png": "./app/javascript/images/vp/sample.taskimagethumb.png",
	"./vp/sample.taskimagethumb_": "./app/javascript/images/vp/sample.taskimagethumb_.png",
	"./vp/sample.taskimagethumb_.png": "./app/javascript/images/vp/sample.taskimagethumb_.png",
	"./vp/samples/01": "./app/javascript/images/vp/samples/01.jpg",
	"./vp/samples/01.jpg": "./app/javascript/images/vp/samples/01.jpg",
	"./vp/samples/02": "./app/javascript/images/vp/samples/02.jpg",
	"./vp/samples/02.jpg": "./app/javascript/images/vp/samples/02.jpg",
	"./vp/samples/03": "./app/javascript/images/vp/samples/03.jpg",
	"./vp/samples/03.jpg": "./app/javascript/images/vp/samples/03.jpg",
	"./vp/samples/04": "./app/javascript/images/vp/samples/04.jpg",
	"./vp/samples/04.jpg": "./app/javascript/images/vp/samples/04.jpg",
	"./vp/samples/05": "./app/javascript/images/vp/samples/05.jpg",
	"./vp/samples/05.jpg": "./app/javascript/images/vp/samples/05.jpg",
	"./vp/samples/06": "./app/javascript/images/vp/samples/06.jpg",
	"./vp/samples/06.jpg": "./app/javascript/images/vp/samples/06.jpg",
	"./vp/samples/07": "./app/javascript/images/vp/samples/07.jpg",
	"./vp/samples/07.jpg": "./app/javascript/images/vp/samples/07.jpg",
	"./vp/samples/08": "./app/javascript/images/vp/samples/08.jpg",
	"./vp/samples/08.jpg": "./app/javascript/images/vp/samples/08.jpg",
	"./vp/samples/09": "./app/javascript/images/vp/samples/09.png",
	"./vp/samples/09.png": "./app/javascript/images/vp/samples/09.png",
	"./vp/samples/10": "./app/javascript/images/vp/samples/10.jpg",
	"./vp/samples/10.jpg": "./app/javascript/images/vp/samples/10.jpg",
	"./vp/samples/11": "./app/javascript/images/vp/samples/11.jpg",
	"./vp/samples/11.jpg": "./app/javascript/images/vp/samples/11.jpg",
	"./vp/samples/12": "./app/javascript/images/vp/samples/12.jpg",
	"./vp/samples/12.jpg": "./app/javascript/images/vp/samples/12.jpg",
	"./vp/samples/13": "./app/javascript/images/vp/samples/13.jpg",
	"./vp/samples/13.jpg": "./app/javascript/images/vp/samples/13.jpg",
	"./vp/samples/14": "./app/javascript/images/vp/samples/14.jpg",
	"./vp/samples/14.jpg": "./app/javascript/images/vp/samples/14.jpg",
	"./vp/samples/15": "./app/javascript/images/vp/samples/15.jpg",
	"./vp/samples/15.jpg": "./app/javascript/images/vp/samples/15.jpg",
	"./vp/samples/16": "./app/javascript/images/vp/samples/16.jpg",
	"./vp/samples/16.jpg": "./app/javascript/images/vp/samples/16.jpg",
	"./vp/samples/17": "./app/javascript/images/vp/samples/17.jpg",
	"./vp/samples/17.jpg": "./app/javascript/images/vp/samples/17.jpg",
	"./vp/samples/18": "./app/javascript/images/vp/samples/18.jpg",
	"./vp/samples/18.jpg": "./app/javascript/images/vp/samples/18.jpg",
	"./vp/samples/19": "./app/javascript/images/vp/samples/19.jpg",
	"./vp/samples/19.jpg": "./app/javascript/images/vp/samples/19.jpg",
	"./vp/samples/20": "./app/javascript/images/vp/samples/20.jpg",
	"./vp/samples/20.jpg": "./app/javascript/images/vp/samples/20.jpg",
	"./vp/samples/21": "./app/javascript/images/vp/samples/21.jpg",
	"./vp/samples/21.jpg": "./app/javascript/images/vp/samples/21.jpg",
	"./vp/samples/22": "./app/javascript/images/vp/samples/22.jpg",
	"./vp/samples/22.jpg": "./app/javascript/images/vp/samples/22.jpg",
	"./vp/samples/23": "./app/javascript/images/vp/samples/23.jpg",
	"./vp/samples/23.jpg": "./app/javascript/images/vp/samples/23.jpg",
	"./vp/samples/24": "./app/javascript/images/vp/samples/24.jpg",
	"./vp/samples/24.jpg": "./app/javascript/images/vp/samples/24.jpg",
	"./vp/samples/25": "./app/javascript/images/vp/samples/25.jpg",
	"./vp/samples/25.jpg": "./app/javascript/images/vp/samples/25.jpg",
	"./vp/samples/26": "./app/javascript/images/vp/samples/26.jpg",
	"./vp/samples/26.jpg": "./app/javascript/images/vp/samples/26.jpg",
	"./vp/samples/27": "./app/javascript/images/vp/samples/27.jpg",
	"./vp/samples/27.jpg": "./app/javascript/images/vp/samples/27.jpg",
	"./vp/samples/28": "./app/javascript/images/vp/samples/28.jpg",
	"./vp/samples/28.jpg": "./app/javascript/images/vp/samples/28.jpg",
	"./vp/slider.index.01": "./app/javascript/images/vp/slider.index.01.jpg",
	"./vp/slider.index.01.jpg": "./app/javascript/images/vp/slider.index.01.jpg",
	"./vp/slider.index.02": "./app/javascript/images/vp/slider.index.02.jpg",
	"./vp/slider.index.02.jpg": "./app/javascript/images/vp/slider.index.02.jpg",
	"./vp/slider.index.03": "./app/javascript/images/vp/slider.index.03.jpg",
	"./vp/slider.index.03.jpg": "./app/javascript/images/vp/slider.index.03.jpg",
	"./vp/slider.index.04": "./app/javascript/images/vp/slider.index.04.jpg",
	"./vp/slider.index.04.jpg": "./app/javascript/images/vp/slider.index.04.jpg",
	"./vp/slider.index.05": "./app/javascript/images/vp/slider.index.05.jpg",
	"./vp/slider.index.05.jpg": "./app/javascript/images/vp/slider.index.05.jpg",
	"./vp/slider.index.forum": "./app/javascript/images/vp/slider.index.forum.jpg",
	"./vp/slider.index.forum.jpg": "./app/javascript/images/vp/slider.index.forum.jpg",
	"./vp/slider.index.perepis": "./app/javascript/images/vp/slider.index.perepis.jpg",
	"./vp/slider.index.perepis.jpg": "./app/javascript/images/vp/slider.index.perepis.jpg",
	"./vp/tutorialpopup.1": "./app/javascript/images/vp/tutorialpopup.1.svg",
	"./vp/tutorialpopup.1.svg": "./app/javascript/images/vp/tutorialpopup.1.svg",
	"./vp/tutorialpopup.2": "./app/javascript/images/vp/tutorialpopup.2.svg",
	"./vp/tutorialpopup.2.svg": "./app/javascript/images/vp/tutorialpopup.2.svg",
	"./vp/tutorialpopup.3": "./app/javascript/images/vp/tutorialpopup.3.svg",
	"./vp/tutorialpopup.3.svg": "./app/javascript/images/vp/tutorialpopup.3.svg",
	"./vp/tutorialpopup.4": "./app/javascript/images/vp/tutorialpopup.4.svg",
	"./vp/tutorialpopup.4.svg": "./app/javascript/images/vp/tutorialpopup.4.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";